/* @flow strict */

import * as React from 'react';

type PropsType = {
  handleChangeInput: ({}) => void,
  email: string,
  tel: string
};

const EmailNumber = ({ handleChangeInput, email, tel }: PropsType): React.Element<'form'> => {
  return (
    <>
      <header>
        <h1>Welcome to Sparxo</h1>
        <h4 className="sub-header">
         Event goers have questions, how can they best react you?
        </h4>
      </header>
      <form>
        <div className="form-group">
          <label htmlFor="email">Event producer contact email</label>

          <div className="input-group">
            <input
              type="email"
              className="form-control"
              id='email'
              value={email}
              onChange={handleChangeInput}
            />
            <span className="validationMessage">Incorrect email</span>
          </div>
        </div>

        <br/>

        <div className="form-group" style={{ marginBottom: '170px' }}>
          <label htmlFor="tel">Event producer contact number</label>

          <div className="input-group">
            <input
              type="tel"
              className="form-control"
              id='tel'
              value={tel}
              onChange={handleChangeInput}
            />
          </div>
        </div>
      </form>
    </>
  );
};

export default EmailNumber;
